const joinUrls = (baseUrl: string, path: string) => {
  return new URL(path, baseUrl).href;
};

export default joinUrls;
